import type { Component } from 'vue'

import AppLayout from './AppLayout.vue'
import AuthLayout from './AuthLayout.vue'
import BlankLayout from './BlankLayout.vue'
import McpLayout from './McpLayout.vue'

// Layout registry keyed by route meta.layout. App.vue resolves it for every route.
export const layouts: Record<'app' | 'auth' | 'blank' | 'mcp', Component> = {
  app: AppLayout,
  auth: AuthLayout,
  blank: BlankLayout,
  mcp: McpLayout,
}
